export const zIndexes = {
  planningColumnHeader: 111,
  sprintMenuList: 112,
  challengeBadge: 2,
  challengeMenu: 3,
  fixedArea: 5,
};
